import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import DetailsRoundedIcon from '@material-ui/icons/DetailsRounded';
import { makeStyles } from '@material-ui/core';
import { Collections } from '@material-ui/icons';

import { LockIconContainer } from './PrivateContentUtils';


const useStyles = makeStyles(() => {
  return {
    playIcon: {
      color: '#fff',
      position: 'absolute',
      top: '50%',
      left: '50%',
      fontSize: '24px',
      transform: 'translate(-50%, -50%)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: 10,
    },
  };
});

function LiveEventsContent(props) {
  const {
    linkToDirectTo,
    coverPhoto,
    subscribed,
    isBanned,
    isLiveEventsSection,
    shouldBlurContent,
    isGallery,
  } = props;

  const isLocked = !subscribed || isBanned;
  const classes = useStyles();

  if (!isLiveEventsSection) {
    return null;
  }

  const IconComponent = !isGallery ? DetailsRoundedIcon : Collections;

  return (
    <Link className="content-item gallery-item live-events-section" to={linkToDirectTo}>
      <div>
        <img
          alt="Private Gallery"
          className={classnames({ 'blur': shouldBlurContent })}
          src={coverPhoto}
          style={{ height: '100%' }}
        />
        <div className={classes.playIcon}>
          <IconComponent
            style={{
              fontSize: 50,
              transform: !isGallery ? 'rotate(-90deg)' : '',
              margin: 'auto',
            }}
          />
        </div>
        <LockIconContainer
          isLocked={isLocked}
        />
      </div>
    </Link>
  );
}

export default LiveEventsContent;
